import { List, ListItemButton, ListItemText, Skeleton, Typography } from '@mui/material'
import { InputSearch } from 'components/Inputs/TextField/Search'
import { useThemeStore } from 'contexts/ThemeStore'
import { PartnerDTO } from 'dtos/PartnerDTO'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PostpaidPartnerService } from 'services/PospaidPartner'
import { Content, Describer, InputSearchContent, ListItemProvider, ListItemProviderContent, Provider, ProviderList } from './styles'

interface IRawProvider {
  name: string
}

function RawProvider(props: IRawProvider) {
  const navegation = useNavigate()
  return (
    <ListItemProvider>
      <ListItemProviderContent>
        <ListItemButton onClick={() => navegation(`/auth/${props.name}`)} sx={{ p: 0.3 }}>
          <ListItemText sx={{ textAlign: 'center', p: 0 }}>{props.name}</ListItemText>
        </ListItemButton>
      </ListItemProviderContent>
    </ListItemProvider>
  )
}

function SkalatonOfListItemProvider() {
  return (
    <ListItemProvider>
      <ListItemProviderContent>
        <Skeleton animation='wave' variant='text' height='40px' width='100%' />
      </ListItemProviderContent>
    </ListItemProvider>
  )
}

function Home() {
  const [listUsernameOfProvider, setListUsernameOfProvider] = useState<Array<PartnerDTO>>([])
  const [listUsernameOfProviderSearch, setListUsernameOfProviderSearch] = useState<Array<PartnerDTO>>(listUsernameOfProvider)
  const [loadingSearch, setLoadingSearch] = useState<boolean>(true)
  const [loadingGetUsername, setLoadingGetUsername] = useState<boolean>(true)
  const { theme, switchTheme } = useThemeStore()

  useEffect(() => {
    if (theme.type !== 'guigotv') switchTheme('guigotv')
    const getUsername = async () => {
      setLoadingGetUsername(true)
      const partnerDTOs = await PostpaidPartnerService.PartnerController.getUsername()
      setListUsernameOfProvider(partnerDTOs)
      setListUsernameOfProviderSearch(partnerDTOs)
      setLoadingGetUsername(false)
    }
    getUsername()
  }, [])

  const handleSearch = (search: string) => {
    setLoadingSearch(true)
    const save = listUsernameOfProvider.filter((it) => it.username.toLowerCase().includes(search.toLowerCase()))
    setListUsernameOfProviderSearch(save)
    setLoadingSearch(false)
  }

  return (
    <Content>
      <Describer>
        <Typography align='center' paragraph variant='h3' sx={{ marginLeft: '10%', marginRight: '10%' }}>
          Selecione seu parceiro
        </Typography>
        <Typography align='center' variant='subtitle2' sx={{ marginLeft: '10%', marginRight: '10%' }}>
          Com que parceiro você assinou?
        </Typography>
      </Describer>
      <Provider>
        <InputSearchContent>
          <InputSearch variant='standard' onChange={(e) => handleSearch(e)} />
        </InputSearchContent>
        <ProviderList>
          <List>
            {loadingGetUsername || loadingSearch
              ? [...Array(20)].map((it: number, index: number) => <SkalatonOfListItemProvider key={`skalaton-${index}`} />)
              : listUsernameOfProviderSearch.map((partnerDTO) => <RawProvider key={partnerDTO.id} name={partnerDTO.username} />)}
          </List>
        </ProviderList>
      </Provider>
    </Content>
  )
}

export default Home
